<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <!-- <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a> -->
      </v-col>
      <template v-if="!isXsLayout()">
        <v-col style="background-color: #FFFFFF; position: relative;" class="text-center">
          <v-row class="signup-form overflow-hidden text-center">
            <v-card-title class="font-weight-black">お問い合わせ完了</v-card-title>
              <p style="color: #9E9EA7;" class="text-center font-weight-black">お問い合わせいただきありがとうございました。</p>
              <p style="color: #9E9EA7;" class="">お問い合わせを受け付けました。</p>
              <p style="color: #9E9EA7;" class="">折り返し、担当者よりご連絡いたしますので、</p>
              <p style="color: #9E9EA7;" class="">恐れ入りますが、しばらくお待ちください。</p>
              <p style="color: #9E9EA7;" class="">なお、ご入力いただいたメールアドレス宛に</p>
              <p style="color: #9E9EA7;" class="">受付完了メールを配信しております。</p>
              <p style="color: #9E9EA7;" class="">完了メールが届かない場合、処理が正常に</p>
              <p style="color: #9E9EA7;" class="">行われていない可能性があります。</p>
              <p style="color: #9E9EA7;" class="">大変お手数ですが、再度お問い合わせの</p>
              <p style="color: #9E9EA7;" class="">手続きをお願い致します。</p>
            <v-card-text class="text-center pt-0">
              <ValidationObserver>
                <v-row>
                  <v-col cols=12 class="text-center">
                    <v-btn
                      href="/"
                      color="primary"
                      class="button-shadow ma-4"
                      width="50%"
                    >トップページへ</v-btn>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-card-text>
          </v-row>
        </v-col>
      </template>
      <template v-else>
        <v-col class="text-center mt-12">
          <v-row justify="center">
            <v-col cols="12" class="font-weight-black">お問い合わせ完了</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">お問い合わせいただきありがとうございました。</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">お問い合わせを受け付けました。</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">折り返し、担当者よりご連絡いたしますので、</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">恐れ入りますが、しばらくお待ちください。</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">なお、ご入力いただいたメールアドレス宛に</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">受付完了メールを配信しております。</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">完了メールが届かない場合、処理が正常に</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">行われていない可能性があります。</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">大変お手数ですが、再度お問い合わせの</v-col>
            <v-col cols="12" class="font-weight-black text-left" style="color: #9E9EA7;">手続きをお願い致します。</v-col>
            <v-card-text class="text-center pt-0">
              <ValidationObserver>
                <v-row>
                  <v-col cols=12 class="text-center">
                    <v-btn
                      href="/"
                      color="primary"
                      class="button-shadow ma-4"
                      width="50%"
                    >トップページへ</v-btn>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-card-text>
          </v-row>
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'InquiryFinishPage',
  loading: false,
  height: window.innerHeight,
  methods: {
    isXsLayout() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true;
      }
      return false;
    },
  }
}
</script>
<style>
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;
}
.hr-text:before {
  content: '';
  background: -webkit-linear-gradient(left, transparent, #818078, transparent);
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 .5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
.signup-form{
  max-width:550px; position:absolute; top:50%; left: 50%; transform: translate(-50%, -50%);
}
@media(max-width: 959px) {
  .signup-form{
    position:relative;
    top: 20%;
  }
}
</style>